import { render, staticRenderFns } from "./FileExcel.vue?vue&type=template&id=0dd70ff8"
import script from "./FileExcel.vue?vue&type=script&lang=js"
export * from "./FileExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports